import { Modal } from "antd";
import useCriarMarcaEquipamento from "core/features/equipamento/hooks/useCriarMarcaEquipamento";
import { useForm } from "react-hook-form";
import Field from "ui/components/Input/Field";
import FooterModal from "ui/components/Button/FooterModal";

interface ModalCadastroMarcaEquipamentoProps {
  isOpen: boolean;
  onClose: () => any;
  onSaved: ({ id, nome }: { id: string; nome: string }) => any;
}

function ModalCadastroMarcaEquipamento({
  isOpen,
  onClose,
  onSaved,
}: ModalCadastroMarcaEquipamentoProps) {
  const { control, handleSubmit } = useForm<{ nome: string }>({
    defaultValues: {
      nome: "",
    },
  });

  const { mutate: criarMarcaEquipamento, isLoading } =
    useCriarMarcaEquipamento();

  const onSubmit = ({ nome }: { nome: string }) => {
    criarMarcaEquipamento(nome, {
      onSuccess: ({ id }) => onSaved({ id, nome }),
    });
  };

  return (
    <Modal
      width="500px"
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onSubmit={handleSubmit(onSubmit)}
          onClose={() => {
            onClose();
          }}
          isLoadingSave={isLoading}
          isDisabled={isLoading}
          showRegisterAnother={false}
          primaryButtonText="Criar marcca"
        />
      }
      centered
      title="Cadastrar marca de equipamento"
      visible={isOpen}
      onCancel={onClose}
    >
      <Field
        control={control}
        label="Nome"
        name="nome"
        rules={{ required: true }}
      />
    </Modal>
  );
}

export default ModalCadastroMarcaEquipamento;
